import { render, staticRenderFns } from "./ConnectWalletDropdown.vue?vue&type=template&id=038179ba&scoped=true"
import script from "./ConnectWalletDropdown.vue?vue&type=script&lang=js"
export * from "./ConnectWalletDropdown.vue?vue&type=script&lang=js"
import style0 from "./ConnectWalletDropdown.vue?vue&type=style&index=0&id=038179ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038179ba",
  null
  
)

export default component.exports